<template>
<div>
    <v-container fluid>
        <v-layout row wrap>
        <v-flex xs12 v-for="item of clinicsListReactive" :key="item.id">
            <v-card elevation-1 class="mb-2" :dark="item.isActive">
                <v-card-title>
                    <div>
                        <span class="subheading">{{ item.name }}</span>      
                    </div>
                    <v-spacer></v-spacer>
                    <v-btn icon :to="`/catalog-lpu/${item.id}`"><v-icon>edit</v-icon></v-btn>
                </v-card-title>
            </v-card>
        </v-flex>
        </v-layout>
    </v-container>
</div>
</template>
<script>
export default {
    props: {
        clinicsList: {
            type: Array,
            required: true
        }
    },
    computed: {
        clinicsListReactive() {
            return this.clinicsList
        }
    }
}
</script>
